"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Checkbox = ({ value, onChange, disabled, error, id }) => {
    const handleOnCheck = (e) => {
        onChange(e.target.checked, e);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('relative flex h-8 w-8 items-center justify-center rounded border-2 focus-within:ring focus-within:ring-blue-4/40', {
            'border-blue-5': value && !error,
            'border-grey-3': !value && !error,
            'border-red-5': error,
            'opacity-40': disabled,
        }) },
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "16", viewBox: "0 0 19 16", className: (0, classnames_1.default)('', value ? 'opacity-100' : 'opacity-0') },
            react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round" },
                react_1.default.createElement("g", { stroke: "#004BB9", strokeWidth: "4" },
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("path", { d: "M9 16.22L14.019 21.5 24 11", transform: "translate(-257.000000, -481.000000) translate(250.000000, 472.000000)" }))))),
        react_1.default.createElement("input", { type: "checkbox", className: "absolute left-0 top-0 h-full w-full cursor-pointer opacity-0", checked: value, onChange: handleOnCheck, id: id, disabled: disabled })));
};
exports.Checkbox = Checkbox;
